<template>
  <td v-if="showDiff && hasDiff" class="text-right">
    <table width="100%">
      <tr style="border-bottom: 1px solid #aaaaaa">
        <th class="diff diff-old">
          {{ currentDate }}
        </th>
        <th class="diff diff-new">
          {{ currencyDate }}
        </th>
      </tr>
      <tr>
        <td class="diff diff-old" v-html="isEmptyCurrencyValue(currentValue, currencySymbol)"></td>
        <td class="diff diff-new" v-html="isEmptyCurrencyValue(currencyValue, currencySymbol)"></td>
      </tr>
    </table>
  </td>
  <td v-else class="text-right" :class="extraClasses">
    <span v-html="isEmptyCurrencyValue(currencyValue, currencySymbol)" />
    <br />
    <div
      v-if="this.showPercentage && validPercentageChange(this.percentageValue)"
      v-bind:class="getLabelStyle(this.percentageValue, this.direction, this.isCreditSafeReport)"
    >
      <span v-bind:class="getGlyphicon(this.percentageValue, this.direction, this.isCreditSafeReport)"></span>
      {{ formatPercentage(this.percentageValue) }}
    </div>
  </td>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';

export default {
  mixins: [toolsMixin],
  props: [
    'currencyDate',
    'currencySymbol',
    'currencyValue',
    'currentDate',
    'currentValue',
    'direction',
    'extraClasses',
    'hasDiff',
    'isCreditSafeReport',
    'oldDate',
    'percentageValue',
    'showDiff',
    'showPercentage',
  ],
};
</script>
